export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Immagini totali generate',
        cost: 'Costo',
        imagesPerDay: 'Immagini/giorno',
    },
};
